import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';
import { message } from 'antd';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createTaskInfosAction = createActionCreator(constant.taskInfos, o => o);
export const createExportUrlAction = createActionCreator(constant.url, o => o);

let taskInfosUrl = Urls.TaskStatisticUrl.taskInfos;
let exportUrl = Urls.TaskStatisticUrl.exportTargetPvTotal;
let mail10Url = Urls.TaskStatisticUrl.sendMail10;
let mail18Url = Urls.TaskStatisticUrl.sendMail18;

//获取数据统计（表格数据）
export const getTaskInfos = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let search = getState().statisticsView.search;
            let response = await request(taskInfosUrl + paramsEncode(Object.assign({}, search, { filtration: undefined })));
            dispatch(createTaskInfosAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

// 
export const handleSearch = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}

export const getExportUrl = (search) => {
    return (dispatch, getState) => {
        let search = getState().statisticsView.search;
        let token = JSON.parse(localStorage.getItem('HippoUserInfo')).token;
        let url = exportUrl + paramsEncode(Object.assign({}, search, { filtration: undefined })) + "&token=" + token;
        dispatch(createExportUrlAction(url));
    }
}


export const sendMail = (type) => {
    return async (dispatch, getState) => {
        try {
            if (type === '10') {
                let response = await request(mail10Url);
            }
            if (type === '18') {
                let response = await request(mail18Url);
            }
            message.success('发送成功')
        } catch (e) {
            message.error('发送失败');
            throw new Error(e);
        }

    }
}



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/statistics-view/action.js